<template>
  <Modal v-model="modal" :title="$t('name.cex_take.active_no')" width="350" footer-hide>
    <Form ref="form" :model="form" :rules="rule">
      <FormItem :label="$t('name.cex_take.code')" prop="code">
        <Input v-model="form.code" />
      </FormItem>
    </Form>
    <Button type="warning" :loading="loading" @click="onPost" long>{{ $t('name.confirm') }}</Button>
  </Modal>
</template>
<script>
import { noCode } from '@/api/cex_take'

export default {
  data() {
    return {
      modal: false,
      loading: false,
      form: {
        code: ''
      },
      rule: {
        code: [
          { required: true, message: ' ', trigger: 'blur' }
        ]
      },
    }
  },
  methods: {
    open() {
      this.modal = true

      // 用户信息
      this.form.code = ''

      // 清空验证
      this.$refs.form.resetFields()
    },
    close() {
      this.modal = false
    },
    onPost() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true
          noCode(this.form).then(res => {
            this.close()
            this.loading = false
            this.$Message.success(this.$t('message.' + res.message))
          }).catch(res => {
            this.loading = false
            this.$Message.error(res.message)
          })
        }
      })
    }
  }
}
</script>